import React, { useState } from "react";
import toast from "react-hot-toast";
import Filter from "./Filter/Filter";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import ListCard from "./ListCard";
import Loading from "../../../../Utils/Loading/Loading";
import NotFound from "../../../../Utils/NotFound/NotFound";
// import ListMenu from "./ListMenu/ListMenu"; // Uncomment if needed later

const backend = await new Backend().init();

export default function GenerateBill() {
  const windowSize = useSize();
  const userType = Number(localStorage.getItem("user_type") || 7);

  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const loadUser = async (startDate, endDate) => {
    setStart(startDate);
    setEnd(endDate);
    setLoading(true);

    try {
      const baseData = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        start: startDate,
        end: endDate,
      };

      // Add specific ID based on userType
      if (userType === 5) baseData.broker_id = localStorage.getItem("id");
      if (userType === 3) baseData.master_id = localStorage.getItem("id");
      if (userType === 2) baseData.super_id = localStorage.getItem("id");
      if (userType === 1) baseData.admin_id = localStorage.getItem("id");

      const response = await backend.user_filter_bill(baseData);
      setLoading(false);

      if (response.error === "False") {
        setUserList(response.user || []);
      } else {
        toast.error(response.message || "Failed to fetch users");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error("Something went wrong while loading users");
    }
  };

  const contentHeight = windowSize[1] - 160;

  return (
    <div className="generate-bill-container">
      <Filter records={userList.length} load={loadUser} />

      <div
        style={{
          height: contentHeight,
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={contentHeight} />
          </div>
        ) : userList.length > 0 ? (
          <div
            style={{
              height: contentHeight,
              overflowY: "auto",
            }}
          >
            {userList.map((item, index) => (
              <ListCard
                key={item.id || index}
                item={item}
                index={index}
                start={start}
                end={end}
                userType={userType}
              />
            ))}
          </div>
        ) : (
          <NotFound height={contentHeight} title="Nothing here" subtext="No User Found." />
        )}
      </div>
    </div>
  );
}
